<template >
  <div class="mainbody">
    <div class="tableHead">
      <div class="box">
        <p class="title1">已认证</p>
        <p class="title2">{{ authenticationAisCount }}个校友</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">过期未重新激活</p>
        <p class="title2">{{ expiredAisCount }}个校友</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">本周完成重新激活</p>
        <p class="title2">{{ weekReactivateCount }}个校友</p>
      </div>
    </div>
    <div class="tableInfo">
      <div class="filter">
        <div class="wrap">
          <div class="label">校友名称：</div>
          <el-input
            @keyup.enter.native="$query()"
            size="medium"
            v-model="inputing.where_name"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="wrap">
          <div class="label">校友学号：</div>
          <el-input
            @keyup.enter.native="$query()"
            size="medium"
            v-model="inputing.where_student_no"
            placeholder="请输入"
          ></el-input>
        </div>

        <div class="btn-group">
          <div class="search-btn"></div>
          <el-button size="small" @click="$query()" type="primary"
            >查询</el-button
          >
          <el-button size="small" @click="$reset()">重置</el-button>
        </div>
      </div>
      <div class="filterDown">
        <div class="wrap">
          <div class="label">UID：</div>
          <el-input
            @keyup.enter.native="$query()"
            v-model="inputing.where_uid"
            size="medium"
            placeholder="请输入"
          ></el-input>
        </div>
      </div>
      <div class="export-btn">
        <img src="@/assets/icon_export.png" />
        <span class="title" style="padding-left: 5px" @click="exportPhoto()"
          >一键导出列表</span
        >
      </div>
      <el-table
        :data="data_list"
        @row-click="toDetails"
        @filter-change="filterChange"
        v-loading="loading"
      >
        <el-table-column prop="uid" label="UID" min-width="1"></el-table-column>
        <el-table-column
          prop="student_no"
          label="学号"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="name_cn"
          label="姓名"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="year"
          label="入学年份"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="member_type"
          label="会员类型"
          min-width="1"
          :filters="optionsMemberType"
          filter-placement="bottom-end"
          column-key="filterMembertype"
        ></el-table-column>
        <el-table-column
          prop="activation_count"
          label="激活次数"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="expirationTime"
          label="过期时间"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="resultStr"
          label="激活状态"
          min-width="1"
          :filters="optionsActivation"
          filter-placement="bottom-end"
          column-key="filterResult"
        ></el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
      <ExportActivation ref="_exportActivationDialog"></ExportActivation>
    </div>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import ExportActivation from "@/components/dialog/exportActivation";

export default {
  components: {
    ExportActivation,
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsActivation: Constant.options_activation,
      optionsMemberType: Constant.options_member_type,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      authenticationAisCount: 0,
      expiredAisCount: 0,
      weekReactivateCount: 0,
      screen_result: "",
      screen_member_type: "",
      inputing: {
        where_name: "",
        where_student_no: "",
        where_uid: "",
      },
      filter: {
        where_name: "",
        where_student_no: "",
        where_uid: "",
        screen_member_type: "",
      },
      loading: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList: function () {
      this.loading = true;
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: this.pageMaxSize,
        screen_result: this.screen_result,
        screen_member_type: this.screen_member_type,
      };
      // 如果搜索参数存在则带参查询
      if (this.filter.where_name != "") {
        params["where_name"] = this.filter.where_name;
      }
      if (this.filter.where_student_no != "") {
        params["where_student_no"] = this.filter.where_student_no;
      }
      if (this.filter.where_uid != "") {
        params["where_uid"] = this.filter.where_uid;
      }
      this.$api
        .activationList(params)
        .then(({ data }) => {
          this.authenticationAisCount = data.Data.authenticationAisCount;
          this.expiredAisCount = data.Data.expiredAisCount;
          this.weekReactivateCount = data.Data.weekReactivateCount;

          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.loading = false;
          this.data_list.forEach((info) => {
            this.optionsActivation.forEach((examin) => {
              if (info.result == examin.value) {
                info.resultStr = examin.text;
              }
            });
            this.optionsMemberType.forEach((memb) => {
              if (info.member_type == memb.value) {
                info.memberTypeStr = memb.text;
              }
            });
            info.expirationTime = Utils.dateFormat(info.expiration_time * 1000);
            info.member_type = Constant.formar_member_type[info.member_type];
          });
        })
        .catch(({ error }) => {});
    },
    getRegisterData() {},
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 过滤
    filterChange(filters) {
      if (filters.filterResult) {
        this.screen_result = StrUtils.getStr4List1(filters.filterResult);
      }
      if (filters.filterMembertype) {
        this.screen_member_type = StrUtils.getStr4List1(filters.filterMembertype);
      }

      // if (this.screen_result == "") this.screen_result = undefined;
      // if (this.screen_member_type == "") this.screen_member_type = undefined;
      this.getList();
    },
    // 查看详情
    toDetails(row, column, event) {
      this.$router.push({
        path: "/wxapp/auth_activation_details",
        query: {
          wx_openid: row.wx_openid,
        },
      });
    },
    // 将输入结果存储到查询参数中
    $query() {
      this.filter = JSON.parse(JSON.stringify(this.inputing));
      this.getList();
    },
    // 将输入结果,查询参数重置
    $reset() {
      this.inputing = {
        where_name: "",
        where_student_no: "",
        uid: "",
      };
      this.filter = {
        where_name: "",
        where_student_no: "",
        uid: "",
        screen_member_type: "",
      };
      this.screen_result = "";
      this.getList();
    },
    // 一键导出
    exportPhoto() {
      if (this.data_list.length > 0) {
        console.log(this.data_list);
        this.$nextTick(() => {
          this.$refs._exportActivationDialog.show(
            this.filter,
            this.screen_member_type,
            this.screen_result,
          );
        });
      } else {
        this.$message.error("未存在需要导出的数据");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .tableHead {
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.mainbody .tableHead .box {
  padding: 24px;
  width: 29%;
  height: 50px;
  float: left;
  text-align: center;
}
.mainbody .tableHead .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}
.mainbody .tableHead .title2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
}
.mainbody .tableHead .aLine {
  float: left;
  background-color: #e9e9e9;
  width: 1px;
  height: 56px;
  margin-top: 25px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.filter {
  padding: 23px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #595959;
}
.filter .wrap {
  display: flex;
  flex: 1;
  margin-right: 20px;
  align-items: center;
}
.filter .wrap .el-input {
  width: 65%;
}
.filterDown {
  padding: 23px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #595959;
}
.filterDown .wrap {
  display: flex;
  flex: 1;
  margin-right: 20px;
  align-items: center;
}
.filterDown .wrap .el-input {
  width: 29.4%;
}
.filterDown .wrap .label {
  margin-right: 32px;
}
.export-btn {
  display: flex;
  align-items: center;
  margin: 24px 0 16px;
  cursor: pointer;
  color: #595959;
  font-size: 14px;
}
.export-btn img{
  margin-bottom: 2px;
}
.export-btn .title{
  font-weight: 500;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/activationList.vue